import styled from '@emotion/styled';
import { IconButton, Typography } from '@material-ui/core';
import IncrementIcon from '@material-ui/icons/Add';
import DecrementIcon from '@material-ui/icons/Remove';
import { createElement, FC } from 'react';

import { ProjectType } from '../../../generated/graphql';
import theme from '../../../theme';
import { SPACING_UNIT } from '../../constant/spacing';
import { useEditingProjectState } from '../../page/ProjectEditingPage/hooks/useEditingProjectState';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = {
  projectType: ProjectType;
  creationSetAmount: number;
  className?: string;
};

export const InputCreationSetAmount: FC<Props> = ({ projectType, creationSetAmount, className }) => {
  const { updateCreationSetAmount } = useEditingProjectState();

  const minConceptCount = projectType.minConceptCount ?? 1;
  const maxConceptCount = projectType.maxConceptCount ?? 100;

  return (
    <Root className={className}>
      <CreationSetAmountControllerButton
        onClick={() => updateCreationSetAmount(creationSetAmount - 1)}
        disabled={creationSetAmount <= minConceptCount}
      >
        <DecrementIcon fontSize="inherit" />
      </CreationSetAmountControllerButton>
      <CreationSetAmount>
        <Typography variant="subtitle1">{creationSetAmount}</Typography>
      </CreationSetAmount>
      <CreationSetAmountControllerButton
        onClick={() => updateCreationSetAmount(creationSetAmount + 1)}
        disabled={creationSetAmount >= maxConceptCount}
      >
        <IncrementIcon fontSize="inherit" />
      </CreationSetAmountControllerButton>
    </Root>
  );
};

const Root = styled('div')`
  ${flexibleLayoutContainer({ direction: 'row', alignItems: 'center' })}
`;

const CreationSetAmount = styled('div')`
  ${flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
  })}
  min-width: 66px;
  border-radius: 2px;
  border: 1px solid ${theme.palette.divider};
  padding: ${SPACING_UNIT}px;
`;

const CreationSetAmountControllerButton = styled(IconButton)`
  margin-left: ${SPACING_UNIT / 2}px;
  margin-right: ${SPACING_UNIT / 2}px;
  font-size: 16px;
  width: 32px;
  height: 32px;
`;
